export default __webpack_public_path__ + "d94111b3b868280181d15f3c283924af.svg";